export const initialSourceMarketPlaces = [
  {
    id: 'AZ_US',
    name: 'Amazon US',
  },
  {
    id: 'WM',
    name: 'Walmart',
  },
  {
    id: 'ALI_CN',
    name: 'AliExpress China',
  },
  {
    id: 'ALI_US',
    name: 'AliExpress US',
  },
  {
    id: 'CATALOG',
    name: 'Catalog [Beta]',
  },
  {
    id: 'CJ_US',
    name: 'CJ US',
  },
  {
    id: 'CJ_CN',
    name: 'CJ China',
  },
];

export const getInitialFilterValues = () => ({
  statuses: [],
  sourceMarketPlaces: [],
  failedReason: '',
  buyerOrderDateFrom: '',
  buyerOrderDateTo: '',
  selectedSellerAccounts: [],
  destinationPriceFrom: '',
  destinationPriceTo: '',
  profitFrom: '',
  profitTo: '',
  estimatedShippingTimeFrom: '',
  estimatedShippingTimeTo: '',
  ebayGlobalShippingProgram: null,
  lateShipment: null,
});
